import React from "react";

import { Badge, BadgeProps } from "@mantine/core";
import { TbBulb, TbChartBar } from "react-icons/tb";

import { objectiveTypeLabels } from "modules/strategy/utils/constants";

import { IObjective } from "modules/strategy/types/entities";

interface IObjectiveTypeChipProps extends BadgeProps {
  objective_type: IObjective["objective_type"];
  withSuffix?: boolean;
}

const ObjectiveTypeChip: React.FC<IObjectiveTypeChipProps> = props => {
  const { objective_type, withSuffix = true, ...restProps } = props;

  return (
    <Badge
      size="sm"
      tt="capitalize"
      variant="light"
      color={objective_type === "learning" ? "orange" : "indigo"}
      leftSection={
        objective_type === "learning" ? (
          <TbBulb size={13} />
        ) : (
          <TbChartBar size={13} />
        )
      }
      {...restProps}
    >
      {withSuffix
        ? objectiveTypeLabels[objective_type]
        : objectiveTypeLabels[objective_type].split(" ")[0]}
    </Badge>
  );
};

export default React.memo(ObjectiveTypeChip);
